// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__n7kyV","vLegacy":"SelectSecondary_vLegacy__2nd4W","error":"SelectSecondary_error__1xqKc","disabled":"SelectSecondary_disabled__NELKE"};